<template>
  <div>
    <el-input size="mini" placeholder="请输入二级密码" v-model="secondaryPassword" show-password></el-input>
    
    <div class="mt-20 ta-c">
      <el-button v-if="!needCbSecond" size="mini" @click="backToIndex">返回首页</el-button>
      <el-button size="mini" type="primary" @click="submitSecondary">提交密码</el-button>
    </div>
    <div class="ta-c mt-10" style="color: red">
      {{errMsg}}
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {Req_CheckSecondary} from '@/request/organize'
import {Cookie} from '@/util'
import JsEncrypt from 'jsencrypt'
const encruption = function (pwd) {
  const encrypt = new JsEncrypt()
  encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBEOoiPWvS+iCJ7tLbq9d3/ssoB4K4PsfTqqjG22E+59CxvfETSoLOL8UERJPeCRLnM6kfAkmQi5/xqmAbqyMaAVoINRCAHEkGJxwA6rxXCmdgspfKIwHzWlmOj8BYH09uLtdbWS0CwZ1sFtoI+sHp200lvMyq+p6gjilh5/kbJa/YftXAyZAc4hIP0b+jIATYuB5Z1JNjCJMrSRYqnqZEMluTImi7+W+3bQNcex/agRkwqY44RXxiykJEpXFtgeteDGePr1GPi8KMQ9gzKzFj5lb0ih3A4LFgVoyHvDGaeeFoT82AXch/Mt081v9kD5Ce7JXedopYLOvZ2WK7kpiwIDAQAB')
  return encrypt.encrypt(pwd)
}
export default {
  data() {
    return {
      secondaryPassword:'',
      errMsg: 'nisdflsdj'
    }
  },
  props:{
    needCbSecond:{
      type:Boolean,
      default:false
    }
  },
  created() {
    this.secondaryPassword = ''
    this.errMsg = ''
  },
  methods: {
    ...mapMutations(['setShowCheckPassword','setErrorTipsShowState']),
    backToIndex(){
      this.$router.push({path:'/account/keepAccounts'})
    },
    submitSecondary(){
      this.setErrorTipsShowState(true)
      Req_CheckSecondary({secondaryPassword:encruption(this.secondaryPassword)}).then(res => {
        sessionStorage.setItem('secondPasswordIsPass',res)
        this.$emit('successCb',this.needCbSecond ? this.secondaryPassword : undefined)
        this.errMsg = ''
      }).catch(err => {
        this.errMsg = err.message
        this.$catchErr(err)
        this.setErrorTipsShowState(false)
      })
    },
  },
  computed:{
    userInfo() {
      return this.$store.state.userInfo
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Finance/secondaryPwdComponent.vue